import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  ElementRef, Input
} from '@angular/core';
import {Router} from '@angular/router';
import {SessionStorageService} from 'ngx-webstorage';
import {VERSION} from 'app/app.constants';
import {LANGUAGES} from 'app/config/language.constants';
import {Account} from 'app/core/auth/account.model';
import {AccountService} from 'app/core/auth/account.service';
import {LoginService} from 'app/login/login.service';
import {ProfileService} from 'app/layouts/profiles/profile.service';
import {EntityNavbarItems} from 'app/entities/entity-navbar-items';
import {NavbarService} from "../../services/navbar.service";
import {Navbar} from "../../models/navbar";
import {NotificheService} from "../../services/notifiche.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import {filter} from "rxjs/operators";
import {take} from "rxjs";
import {Configurazione} from "../../models/configurazione";
import {DomSanitizer} from "@angular/platform-browser";
import {CambioVisualeService} from "../../services/cambio-visuale-service.service";
import {AmministrazioneService} from "../../services/amministrazione.service";
import {Toolbar} from "../../models/toolbar";
import {FormBuilder, FormGroup} from "@angular/forms";
import {StateStorageService} from "../../core/auth/state-storage.service";
import { HomePageHeaderFooter } from '../../models/home-page-header-footer.model';


@Component({
  selector: 'jhi-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})


export class NavbarComponent extends SubscriptionManager implements OnInit {
  keyword = 'nmTitolo';
  normalSearch = false;
  filterAct = '';
  formSearch: FormGroup;
  inProduction?: boolean;
  isNavbarCollapsed = true;
  languages = LANGUAGES;
  openAPIEnabled?: boolean;
  version = '';
  account: Account | null = null;
  configurazione!: Configurazione;
  lingua!: string;
  loading = false;
  entitiesNavbarItems: any[] = [];
  initialLetterFirstName?: string;
  initialLetterLastName?: string;
  windowSize: number;
  nav: Navbar[] = [];
  logoImage!: any;
  result!: Toolbar[];
  resultNew!: Array<{nmTitolo: string, nmComponent: string, svg: string ,flToolbar: boolean, codice?: string | undefined, macroArea: string}>;
  selectedResult!: Toolbar[];
  countResults = 0;
  @Input() homePageHeaderFooter?: HomePageHeaderFooter;
  @ViewChild('_MD_SEARCH') _md_search!: ElementRef;
  initSearch = false;

  constructor(
    public navServ: NavbarService,
    private loginService: LoginService,
    private sessionStorageService: SessionStorageService,
    private accountService: AccountService,
    private profileService: ProfileService,
    private router: Router,
    public apiservice: NavbarService,
    private confService: ConfigurazioneGeneraleService,
    protected notificheservice: NotificheService,
    private sanitizer: DomSanitizer,
    private cambioVisualeService: CambioVisualeService,
    private amministrazioneService: AmministrazioneService,
    private _fb: FormBuilder,
    protected navService: NavbarService,
    private stateStorageService: StateStorageService
  ) {
    super();
    if (VERSION) {
      this.version = VERSION.toLowerCase().startsWith('v') ? VERSION : `v${VERSION}`;
    }
    this.windowSize = window.innerWidth;
    this.resultNew = [];
    this.formSearch = this._fb.group({
      searchText: ''
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): any {
    this.windowSize = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.windowSize = window.innerWidth;
    this.accountService.identity().subscribe({
      next: (account) => {
        this.account = account
      },
      complete: () => {
        if(this.account){
          this.numeroNotifiche();
          this.notificheservice.aggiornaNotifiche();
        }
      }
    });
    this.confService.configurazione$
      .pipe(filter(configurazione => configurazione !== null), take(1))
      .subscribe(configurazione => {
        this.configurazione = configurazione!;
      });
    this.entitiesNavbarItems = EntityNavbarItems;
    this.subs.sink = this.profileService.getProfileInfo().subscribe(profileInfo => {
      this.inProduction = profileInfo.inProduction;
      this.openAPIEnabled = profileInfo.openAPIEnabled;
    });
    this.lingua = this.sessionStorageService.retrieve('locale');
    if (this.lingua === null) {
      this.lingua = "it";
    }
    this.loading = true;
  }

  routing(component: any): void {
    if (this.account?.id != null) {
      void this.router.navigate([component]);
    } else {
      this.loginService.login();
    }
  }

  collapseNavbar(): void {
    this.isNavbarCollapsed = true;
  }

  login(): void {
    window.localStorage.clear();
    const urlToGo = location.pathname+location.search;
    if(urlToGo.includes("Appuntamenti")){
      console.log("Sono nell'if");
      this.stateStorageService.storeUrl(("/Appuntamenti/prenota-nuovo-appuntamento"))
    }else{
      console.log("Sono nell'else")
      this.stateStorageService.storeUrl((location.pathname+location.search));
    }
    window.onbeforeunload = null;
    this.loginService.login();
  }

  logout(): void {
    this.collapseNavbar();
    window.localStorage.clear();
    if(this.homePageHeaderFooter){
      this.loginService.logout(this.homePageHeaderFooter.BaseURLSito);
    }else{
      this.loginService.logout();
    }
  }

  mostraAttivitaNotifiche(): void {
    this.cambioVisualeService.setCambioVisuale(false);
    if (this.router.url !== 'Cruscotto/le-mie-attivita') {
      localStorage.removeItem('servizioSelezionato');
      void this.router.navigate(['Cruscotto/le-mie-attivita'], {state: {cambioVisuale: false}});
    } else {
      // Utilizza il servizio CambioVisualeService per impostare il nuovo valore
      this.cambioVisualeService.setCambioVisuale(false);
    }
  }

  mostraAttivita(): void {
    this.cambioVisualeService.setCambioVisuale(true);
    if (this.router.url !== 'Cruscotto/le-mie-attivita') {
      localStorage.removeItem('servizioSelezionato');
      void this.router.navigate(['Cruscotto/le-mie-attivita'], {state: {cambioVisuale: true}});
    } else {
      // Utilizza il servizio CambioVisualeService per impostare il nuovo valore
      this.cambioVisualeService.setCambioVisuale(true);
    }
  }

  goToAreaPersonale(): void{
    void this.router.navigate(['private'])
  }

  goToHome(): void {
    localStorage.removeItem('servizioSelezionato');
    if(!this.homePageHeaderFooter){
      window.location.href = this.confService.configurazione.linkHome;
    }else{
      window.location.href = this.homePageHeaderFooter.BaseURLSito;
    }
  }

  goToServizi():void{
    if(this.homePageHeaderFooter){
      window.location.href = this.homePageHeaderFooter.Footer.CategoryServicesLink;
    }else{
      window.location.href = this.confService.configurazione.linkHome;
    }
  }

  searchClick():void{
    this.filterAct = '';
    this.normalSearch = true;
    this.initSearch = true;
    this.selectedResult = this.result;
    this.updateCountResults();
  }

  numeroNotifiche(): void {
    if (this.account) {
      this.subs.sink = this.notificheservice.contaNotifiche().subscribe({
        next: (res) => {
          this.notificheservice.numNotifiche = res;
        }
      });
    }
  }

  getImage(): any {
    if(this.configurazione?.logo) {
      const imageUrl = "data:image/png;base64," + this.configurazione?.logo;
      this.logoImage = this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
      return this.logoImage;
    }
    return ''
  }

  customFilter = function(items: any[], query: string): any[] {
    return items;
  };

  searchInputChange(event: string): void { // input cambiato
    if (event.length > 1) {
      if (event && event !== '') {
        this.subs.sink = this.amministrazioneService.querySearch(event).subscribe({
          next: (res) => {
            if (res !== undefined) {
              this.result = res;
              this.resultNew = [];
              this.result.forEach((macroArea) => {
                macroArea.funzioniServizio.forEach((serv) => {
                  (serv as any).macroArea = macroArea.nmServizio;
                  (serv as any).svg = macroArea.nmSvg;
                  this.resultNew.push(serv as any);
                })
              })
            } else {
              this.result = []
            }
          },
          error: () => {
            this.result = [];
          }
        })
      } else {
        this.result = [];
      }
    } else {
      this.result = [];
    }
  }

  handleMacroArea(nmServizio: string):void{
    this.filterAct = '';
    this.normalSearch = false;
    this.initSearch = true;
    this.selectedResult = this.result.filter(res => res.nmServizio === nmServizio.replace(/<\/?[^>]+(>|$)/g, ""));
    this.formSearch.get('searchText')?.setValue(nmServizio);
    this.updateCountResults();
  }

  handleServizioSingolo(nmTitolo: string, nmServizio: string): void{
    this.filterAct = '';
    this.normalSearch =false;
    this.initSearch = true;
    this.selectedResult = this.result.filter(res => res.nmServizio === nmServizio.replace(/<\/?[^>]+(>|$)/g, ""));
    this.selectedResult = this.selectedResult.map((val) => {
      return {
        ...val,
        funzioniServizio: val.funzioniServizio.filter(serv => serv.nmTitolo === nmTitolo.replace(/<\/?[^>]+(>|$)/g, ""))
      };
    });
    this.formSearch.get('searchText')?.setValue(nmTitolo);
    this.updateCountResults();
  }

  updateCountResults():void{
    this.countResults = 0;
    this.selectedResult.forEach(res => {
      this.countResults += res.funzioniServizio.length;
    })
  }

  sortSelectedResult(azione: string):void{
    this.filterAct = azione;
    if(this.normalSearch){
      if(this.filterAct === '+')
        this.selectedResult.sort((a,b) => (a.nmServizio > b.nmServizio) ? 1 : ((b.nmServizio > a.nmServizio) ? -1 : 0));
      else
        this.selectedResult.sort((a,b) => (a.nmServizio > b.nmServizio) ? -1 : ((b.nmServizio > a.nmServizio) ? 1 : 0));
    }else{
      if(this.filterAct === '+')
        this.selectedResult.at(0)?.funzioniServizio.sort((a,b) => (a.nmTitolo > b.nmTitolo) ? 1 : ((b.nmTitolo > a.nmTitolo) ? -1 : 0));
      else
        this.selectedResult.at(0)?.funzioniServizio.sort((a,b) => (a.nmTitolo > b.nmTitolo) ? -1 : ((b.nmTitolo > a.nmTitolo) ? 1 : 0));
    }
  }

  routingComp(component: any): void {
    if(this.navService.navRouting.has(component)){
      this._md_search.nativeElement.click();
      if (this.account?.id != null) {
        void this.router.navigate([this.navService.navRouting.get(component)]);
      } else {
        this.loginService.login();
      }
    }else{
      if(this.navService.redirectRouting.has(component)){
        this._md_search.nativeElement.click();
        window.open(<string>this.navService.redirectRouting.get(component), "_blank");
      }
    }
  }

  routingTributi(component: any, funzione: {
    nmTitolo: string;
    nmComponent: string;
    flToolbar: boolean;
    codice?: string
  }): void {
    if (this.account?.id != null) {
      this.loading = true;
      localStorage.removeItem('pagamentoJsonForm');
      localStorage.removeItem('pagamentoJsonFormMultiplo');
      this._md_search.nativeElement.click();
      this.navService.updateTributoSubject.next(<string>funzione.codice);
      this.router.navigate([component], { queryParams: { servizio: funzione.codice } }).then();
    } else {
      this._md_search.nativeElement.click();
      this.loginService.redirectUrl = (this.router.createUrlTree([component], { queryParams: { servizio: funzione.codice } }).toString());
      this.stateStorageService.storeUrl(this.loginService.redirectUrl)
      this.loginService.login();
    }
  }

}
